import {
    FETCH_DRIVER_BY_ID_REQUEST,
    FETCH_DRIVER_BY_ID_SUCCESS,
    FETCH_DRIVER_BY_ID_FAILURE,

    REGISTER_DRIVER_FOR_USER_REQUEST,
    REGISTER_DRIVER_FOR_USER_SUCCESS,
    REGISTER_DRIVER_FOR_USER_FAILURE,

    UPDATE_DRIVER_FOR_PARTNER_REQUEST,
    UPDATE_DRIVER_FOR_PARTNER_SUCCESS,
    UPDATE_DRIVER_FOR_PARTNER_FAILURE,

    REGISTER_VEHICLE_FOR_USER_REQUEST,
    REGISTER_VEHICLE_FOR_USER_SUCCESS,
    REGISTER_VEHICLE_FOR_USER_FAILURE,

    UPDATE_VEHICLE_FOR_PARTNER_REQUEST,
    UPDATE_VEHICLE_FOR_PARTNER_SUCCESS,
    UPDATE_VEHICLE_FOR_PARTNER_FAILURE,

    FETCH_RECRUITED_VEHICLES_REQUEST,
    FETCH_RECRUITED_VEHICLES_SUCCESS,
    FETCH_RECRUITED_VEHICLES_FAILURE,
} from "../actions/types";


const initialState = {
    drivers: {},
    recruitedVehicles: [],

    loading: false,
    error: null,

    registeringDriver: false,
    registerDriverError: null,

    updatingDriver: false,
    updateDriverError: null,

    registeringVehicle: false,
    registerVehicleError: null,

    updatingVehicle: false,
    updateVehicleError: null,

    fetchingRecruitedVehicles: false,
    recruitedVehiclesError: null,
};


const driverReducer = (
    state = initialState,
    action
) => {

    switch (
        action.type
    ) {

        // =====================================================
        // FETCH DRIVER
        // =====================================================

        case FETCH_DRIVER_BY_ID_REQUEST:
            return {
                ...state,

                loading: true,
                error: null,
            };


        case FETCH_DRIVER_BY_ID_SUCCESS:
            return {
                ...state,

                loading: false,
                error: null,

                drivers: {
                    ...state.drivers,

                    [
                        action.payload
                            .driver_id
                    ]:
                        action.payload,
                },
            };


        case FETCH_DRIVER_BY_ID_FAILURE:
            return {
                ...state,

                loading: false,

                error:
                    action.payload,
            };


        // =====================================================
        // REGISTER DRIVER FOR USER
        // =====================================================

        case REGISTER_DRIVER_FOR_USER_REQUEST:
            return {
                ...state,

                registeringDriver:
                    true,

                registerDriverError:
                    null,
            };


        case REGISTER_DRIVER_FOR_USER_SUCCESS:
            return {
                ...state,

                registeringDriver:
                    false,

                registerDriverError:
                    null,

                drivers: {
                    ...state.drivers,

                    [
                        action.payload
                            .driver_id
                    ]:
                        action.payload,
                },
            };


        case REGISTER_DRIVER_FOR_USER_FAILURE:
            return {
                ...state,

                registeringDriver:
                    false,

                registerDriverError:
                    action.payload,
            };


        // =====================================================
        // UPDATE DRIVER FOR PARTNER
        // =====================================================

        case UPDATE_DRIVER_FOR_PARTNER_REQUEST:
            return {
                ...state,

                updatingDriver:
                    true,

                updateDriverError:
                    null,
            };


        case UPDATE_DRIVER_FOR_PARTNER_SUCCESS:
            return {
                ...state,

                updatingDriver:
                    false,

                updateDriverError:
                    null,

                drivers: {
                    ...state.drivers,

                    [
                        action.payload
                            .driver_id
                    ]:
                        action.payload,
                },
            };


        case UPDATE_DRIVER_FOR_PARTNER_FAILURE:
            return {
                ...state,

                updatingDriver:
                    false,

                updateDriverError:
                    action.payload,
            };


        // =====================================================
        // REGISTER VEHICLE FOR USER
        // =====================================================

        case REGISTER_VEHICLE_FOR_USER_REQUEST:
            return {
                ...state,

                registeringVehicle:
                    true,

                registerVehicleError:
                    null,
            };


        case REGISTER_VEHICLE_FOR_USER_SUCCESS:
            return {
                ...state,

                registeringVehicle:
                    false,

                registerVehicleError:
                    null,
            };


        case REGISTER_VEHICLE_FOR_USER_FAILURE:
            return {
                ...state,

                registeringVehicle:
                    false,

                registerVehicleError:
                    action.payload,
            };


        // =====================================================
        // UPDATE VEHICLE FOR PARTNER
        // =====================================================

        case UPDATE_VEHICLE_FOR_PARTNER_REQUEST:
            return {
                ...state,

                updatingVehicle:
                    true,

                updateVehicleError:
                    null,
            };


        case UPDATE_VEHICLE_FOR_PARTNER_SUCCESS:
            return {
                ...state,

                updatingVehicle:
                    false,

                updateVehicleError:
                    null,

                recruitedVehicles:
                    state.recruitedVehicles.map(
                        (item) =>
                            item.vehicle?.vehicle_id ===
                            action.payload.vehicle_id
                                ? {
                                      ...item,
                                      vehicle:
                                          action.payload,
                                  }
                                : item
                    ),
            };


        case UPDATE_VEHICLE_FOR_PARTNER_FAILURE:
            return {
                ...state,

                updatingVehicle:
                    false,

                updateVehicleError:
                    action.payload,
            };


        // =====================================================
        // FETCH RECRUITED VEHICLES
        // =====================================================

        case FETCH_RECRUITED_VEHICLES_REQUEST:
            return {
                ...state,

                fetchingRecruitedVehicles:
                    true,

                recruitedVehiclesError:
                    null,
            };


        case FETCH_RECRUITED_VEHICLES_SUCCESS:
            return {
                ...state,

                fetchingRecruitedVehicles:
                    false,

                recruitedVehiclesError:
                    null,

                recruitedVehicles:
                    action.payload.data,
            };


        case FETCH_RECRUITED_VEHICLES_FAILURE:
            return {
                ...state,

                fetchingRecruitedVehicles:
                    false,

                recruitedVehiclesError:
                    action.payload,
            };


        default:
            return state;
    }
};


export default driverReducer;